import en from 'RESOURCES/languages/en.json';

const languages = {en};

export default languages;
